import API from 'config/api'

export const getActivity = async (id) => {
  try {
    const response = await API.get(`/activity/${id}`)
    return response
  } catch (error) {
    return error
  }
}


export const getGenerate = async () => {
  try {
    const response = await API.get(`/activity/generate`)
    return response
  } catch (error) {
    return error
  }
}

export const getCode = async () => {
  try {
    const response = await API.get(`/taquilla/get-one-code`)
    return response
  } catch (error) {
    return error
  }
}
